// extracted by mini-css-extract-plugin
export var measureBox = "_98-0";